<template>
  <v-card>
    <v-card-title>
      ورود های امروز
      <v-spacer />
      <v-chip color="primary" small>{{ data.count }} کاربر</v-chip>
    </v-card-title>

    <m-datatable
      :headers="headers"
      :items="data.users || []"
      :showExportBtns="false"
      :filters.sync="filters"
    />

    <v-card-actions>
      <v-spacer />
      <v-btn text @click="$emit('close')">بستن</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import MDatatable from "@/components/m-datatable/MDatatable.vue";

export default {
  name: "TodayLoginsDialog",
  components: { MDatatable },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({ count: 0, users: [] }),
    },
  },
  data() {
    return {
      filters: {},
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "نام",
          value: "name",
        },
        {
          text: "نام کاربری",
          value: "username",
        },
        {
          text: "شماره تماس",
          value: "phone",
        },
        {
          text: "آخرین ورود امروز",
          value: "last_login_today",
          getValue: (item) => item.last_login_today?.split("T")[1]?.substring(0, 5) || "-",
        },
        {
          text: "خرید کرده",
          value: "has_purchased",
          type: "boolean",
        },
        {
          text: "بسته فعال",
          value: "package_name",
          getValue: (item) => item.active_package?.name_display || "ندارد",
        },
        {
          text: "آزمایشی",
          value: "is_trial",
          type: "boolean",
          getValue: (item) =>
            item.active_package ? item.active_package.is_trial : null,
        },
        {
          text: "روز باقی‌مانده",
          value: "remaining_days",
          getValue: (item) =>
            item.active_package?.is_permanent
              ? "دائمی"
              : item.active_package?.remaining_days ?? "-",
        },
      ];
    },
  },
};
</script>